import React, { Component } from 'react'

import PropTypes from 'prop-types'

export default class Button extends Component {
  static propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    onSubmit: PropTypes.func,
    loading: PropTypes.bool,
    loadingText: PropTypes.string,
    disabled: PropTypes.bool,
    title: PropTypes.string
  }

  static defaultProps = {
    className: 'btn btn-primary',
    loading: false,
    loadingText: 'Loading',
    disabled: false
  }

  render() {
    const { name, className, onSubmit, loading, loadingText, disabled, title } = this.props

    return (
      <button title={title} className={className} disabled={loading || disabled} onClick={onSubmit}>
        {loading ? loadingText : name}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/Button.jsx